import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const initialConfigurationState = (state: RootState) => state.configuration;

export const configuratorId = createSelector(
    initialConfigurationState,
    configuration => configuration.configuratorId,
);

export const startingSelections = createSelector(
    initialConfigurationState,
    configuration => configuration.startingSelections,
);

export const startingAttachments = createSelector(
    initialConfigurationState,
    configuration => configuration.startingAttachments,
);
